import { render } from "./FreePracticeRecord.vue?vue&type=template&id=c92d2fc0&scoped=true&ts=true"
import script from "./FreePracticeRecord.vue?vue&type=script&lang=ts"
export * from "./FreePracticeRecord.vue?vue&type=script&lang=ts"

import "./FreePracticeRecord.vue?vue&type=style&index=0&id=c92d2fc0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c92d2fc0"]])

export default __exports__